import React, { useCallback } from 'react';
import { Textarea } from '@gafe/common-ui';

import { useOrderContext, useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';

import styles from './AdditionalNotes.module.scss';

export const AdditionalNotes = () => {
  const state = useOrderContext();
  const dispatch = useOrderDispatch();

  const onAdditionalNotesChange = useCallback(
    (value: string) => {
      const additionalNotes = value.trim().length > 0 ? value : null;

      dispatch({
        type: 'UPDATE_ORDER',
        payload: {
          additionalNotes,
        },
      });
    },
    [dispatch],
  );

  return (
    <OrderBlockWrapper className={styles.wrapper}>
      <section className={styles.title_wrapper}>
        <div className={styles.title}>Additional Notes</div>
        <span className={styles.subtitle}>(optional)</span>
      </section>

      <Textarea
        maxlength={10000}
        name="Additional notes"
        onChange={onAdditionalNotesChange}
        placeholder="Description"
        testId="additional-notes-input"
        value={state.order.additionalNotes ?? ''}
      />
    </OrderBlockWrapper>
  );
};
